<sc-flex fitHeight vertical stretchContent>
  <div [formGroup]="formGroup" class="no-field-space">
    <sc-flex [wrap]="true">
      <sc-action-icon (click)="setPreviewsDay()" iconClass="fa-chevron-left"> </sc-action-icon>

      <sc-content-spacer></sc-content-spacer>

      <mat-form-field appearance="fill" class="date-field">
        <mat-label>
          <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.list-export.filter.from"></sc-dictionary-label>
        </mat-label>
        <input matInput formControlName="date" [matDatepicker]="picker1" type="date-local">
        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
        <mat-datepicker #picker1></mat-datepicker>
      </mat-form-field>

      <sc-content-spacer></sc-content-spacer>

      <sc-action-icon (click)="setNextDay()" iconClass="fa-chevron-right"> </sc-action-icon>

      <sc-content-spacer></sc-content-spacer>

      <app-structure-node-selection class="spaceBehind" (selectedStructureChanged)="onSelectedStructureChanged($event)"
        [selectedNode]="selectedStructureNode">
      </app-structure-node-selection>

      <sc-content-spacer grow></sc-content-spacer>

      <div class="mode-entry" [ngClass]="{'selected': currentMode === 'summarized'}" (click)="setMode('summarized')">
        <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.gantt-chart.mode.summarized"></sc-dictionary-label>
      </div>
      <sc-content-spacer></sc-content-spacer>
      <div class="mode-entry" [ngClass]="{'selected': currentMode === 'detailed'}" (click)="setMode('detailed')">
        <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.gantt-chart.mode.detailed"></sc-dictionary-label>
      </div>
      <sc-content-spacer></sc-content-spacer>
      <sc-action-icon (click)="minimize()" [disabled]="minimized" iconClass="fa-arrows-minimize"></sc-action-icon>
      <sc-content-spacer></sc-content-spacer>
      <sc-action-icon (click)="maximize()" [disabled]="!minimized" iconClass="fa-arrows-maximize"></sc-action-icon>
      <sc-content-spacer [double]="true"></sc-content-spacer>
      <sc-action-icon (click)="zoomOut()" [disabled]="!zoomOutEnabled" iconClass="fa-magnifying-glass-minus"></sc-action-icon>
      <sc-content-spacer></sc-content-spacer>
      <sc-action-icon (click)="zoomIn()" [disabled]="!zoomInEnabled" iconClass="fa-magnifying-glass-plus"></sc-action-icon>
    </sc-flex>
  </div>
  <sc-content-spacer vertical></sc-content-spacer>
  <sc-flex-fitting-content vertical>
    <div class="viewport">
      @if (stationGroups?.length > 0 || stations?.length > 0) {
        <sc-scroll-pane>
          <div class="view">
            <div class="lines" [style.width]="(hours.length * 60 * unit + 1)+ 'px'">
              <app-gantt-lines [unit]="unit" [hours]="hours"></app-gantt-lines>
            </div>
            <div class="top-scale" [style.width]="(hours.length * 60 * unit + 1)+ 'px'">
              <app-gantt-scale [hours]="hours" [unit]="unit"></app-gantt-scale>
            </div>
            <div class="groups-frame" [style.width]="(hours.length * 60 * unit + 1)+ 'px'">
              <div #labelsElm class="labels-frame">
                @for (stationGroup of stationGroups; track stationGroup; let i = $index) {
                  @if (i > 0) {
                    <sc-content-spacer vertical [half]="true"></sc-content-spacer>
                  }
                  <div class="title">
                    {{stationGroup.name}}
                  </div>
                  @for (transportList of stationGroup.transportLists; track transportList; let i = $index) {
                    @if (i > 0) {
                      <sc-content-spacer vertical [half]=true>
                      </sc-content-spacer>
                    }
                    <div class="transport-row-spacer"></div>
                  }
                  @for (station of stationGroup.stationsList; track station; let i = $index) {
                    <sc-content-spacer vertical></sc-content-spacer>
                    <div class="sub-title">{{station.name}}</div>
                    <div class="border-spacer">
                      <div class="transport-row-spacer"></div>
                    </div>
                  }
                }
              </div>
              <div #stationGroupsElm class="station-group" [style.min-width]="(hours.length * 60 * unit + 1)+ 'px'">
                @for (stationGroup of stationGroups; track stationGroup; let i = $index) {
                  @if (i > 0) {
                    <sc-content-spacer vertical [half]="true"></sc-content-spacer>
                  }
                  <div class="title-spacer"></div>
                  <div class="station-group-transports-area">
                    @for (transportList of stationGroup.transportLists; track transportList; let i = $index) {
                      @if (i > 0) {
                        <sc-content-spacer vertical [half]=true>
                        </sc-content-spacer>
                      }
                      <div class="transport-row-container">
                        <app-transport-row [transports]="transportList" [selectedTransportId]="selectedTransportId"
                        [offsetBefore]="offsetBefore" [scale]="unit" (selectedTransport)="selectTransport($event)"></app-transport-row>
                      </div>
                    }
                  </div>
                  @for (station of stationGroup.stationsList; track station; let i = $index) {
                    <sc-content-spacer vertical></sc-content-spacer>
                    <div class="sub-title-spacer"></div>
                    <sc-bordered>
                      <div class="station-transport-area">
                        <div class="transport-row-container">
                          <app-transport-row [transports]="station.transports" [selectedTransportId]="selectedTransportId"
                          [offsetBefore]="offsetBefore" [scale]="unit"(selectedTransport)="selectTransport($event)"></app-transport-row>
                        </div>
                      </div>
                    </sc-bordered>
                  }
                }
              </div>
            </div>
            <div class="bottom-scale" [style.width]="(hours.length * 60 * unit + 1)+ 'px'">
              <app-gantt-scale [hours]="hours" [unit]="unit"></app-gantt-scale>
            </div>
          </div>
        </sc-scroll-pane>
      }
      @if (stationGroups?.length == 0 && stations?.length == 0) {
        <sc-no-data  fitHeight>
        </sc-no-data>
      }
    </div>
  </sc-flex-fitting-content>
  <sc-content-spacer vertical></sc-content-spacer>
  <div class="legend">
    <app-gantt-legend></app-gantt-legend>
  </div>
</sc-flex>
